<template>
  <Modal :modal-key="'prize-details_modal'" @close="$emit('close')" class="modal--prize-details">
    <template slot="header">
      <h2 v-if="getModalForPrizeLeaderboard.type === 'DAILY'">{{ getTranslations.home_modals_prize_details_daily_prize}}</h2>
      <h2 v-if="getModalForPrizeLeaderboard.type === 'WEEKLY'">{{ getTranslations.home_modals_prize_details_weekly_prize }}</h2>
      <h2 v-if="getModalForPrizeLeaderboard.type === 'MONTHLY'">{{ getTranslations.home_modals_prize_details_monthly_prize }}</h2>
      <h2 v-if="getModalForPrizeLeaderboard.type === 'GRAND'">{{ getTranslations.home_modals_prize_details_grand_prize }}</h2>
      <h1 v-if="getModalForPrizeLeaderboard.type === 'DAILY'">{{ getModalForPrizeLeaderboard.activeFrom | getFormat }}</h1>
      <h1 v-else>{{ getModalForPrizeLeaderboard.activeFrom | getFormat }} - {{ getModalForPrizeLeaderboard.activeTo | getFormat }}</h1>
    </template>
    <template slot="body">
      <img :src="getModalForPrizeLeaderboard.imgUrl" alt="">
      <span class="prize-text">{{ getModalForPrizeLeaderboard.headline }}</span>
      <div class="modal-section">
        <h2 class="modal-section__title">{{ getTranslations.home_modals_prize_details_who_wins }}</h2>
        <div class="modal-section__body">
          <p>{{ getModalForPrizeLeaderboard.description }}</p>
        </div>
      </div>
      <div class="modal-section">
        <h2 class="modal-section__title">{{ getTranslations.home_modals_prize_details_eligibility }}</h2>
        <div class="modal-section__body">
          <p>{{ getModalForPrizeLeaderboard.eligibilityCriteria }}</p>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import Modal from '@/components/home/modals/shared/GenericModal';

const moment = require('moment/moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  props: ['getModalForPrizeLeaderboard'],
  name: 'details-leader',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  filters: {
    getFormat(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/prizes/PrizeDetailsForLeaderBoard.vue